module.exports = __webpack_public_path__ + "img/background_c5.ec93efb2.jpg";